import { motion } from "framer-motion";
import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import Typewriter, { Options } from "typewriter-effect";

const startVariants = {
  initial: {
    opacity: 0,
  },
  end: {
    opacity: 1,
    transition: {
      type: "tween",
      bounce: 0.4,
      duration: 0.4,
      delay: 1,
    },
  },
};

const options = {
  strings: [
    "    ",
    "FullStack Developer",
    "Open Source Developer",
    "Next.js Developer",
    "Web Developer",
    "ML Engineer",
    "NLP Enthusiast",
    "Astronomer",
    "App Developer",
    "Future Senior Dev",
    "Technical Speaker",
  ],
  autoStart: true,
  loop: true,
};

function Hero() {
  const btnRef = useRef(null);

  useEffect(() => {
    let rect = btnRef.current.getBoundingClientRect();
  }, []);
  return (
    <motion.section
      id="hero"
      className="h-screen max-w-[1000px]  text-white/25 flex flex-col justify-center   mx-auto font-sfMonoRegular"
      initial="initial"
      animate="end"
      variants={startVariants}
    >
      <div className="">
        <h1 className="text-theme-green mb-[15px] ml-[4px] ">
          Hi, my name is{" "}
        </h1>
      </div>
      <h2 className="name-heading font-calibreRegular text-[40px] font-bold text-theme-gray-light pt-0">
        Pranshu Jain
      </h2>
      <h3 className="text-lg md:text-2xl lg:text-3xl text-textDark mt-2">
        <Typewriter options={options} />
      </h3>
      <p className="bio max-w-[540px] mt-[20px] text-[20px] text-theme-gray-deep font-calibreRegular">
        Skilled in building and deploying robust, scalable solutions from the
        first line of code to full-scale production.
        <br />
        <div className="mt-2"></div>
        <span className="text-theme-green font-semibold tracking-widest">
          Co-op Intern @AMD & Ex-Research Intern @IIT Madras
        </span>
      </p>
      <div
        ref={btnRef}
        className="flex items-center border rounded cursor-pointer w-fit mt-9 border-theme-green hover:bg-theme-green/10 text-theme-green"
      >
        <Link
          rel="noreferrer"
          to="/achievements"
          className=" px-[50px] py-[18px]"
        >
          Let's start with Achievements
        </Link>
      </div>
    </motion.section>
  );
}

export default Hero;
